import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const AlertBox = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  max-width: 320px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const AlertMessage = styled.p`
  font-size: 16px;
  color: #333;
  margin: 0 0 20px 0;
  text-align: center;
  line-height: 1.5;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const AlertButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #00BBD3;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  font-family: 'Noto Sans Thai', sans-serif !important;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #009bb3;
  }

  &:active {
    background-color: #008aa0;
  }
`;

const CustomAlert = ({ message, onClose }) => {
  return (
    <Overlay onClick={onClose}>
      <AlertBox onClick={(e) => e.stopPropagation()}>
        <AlertMessage>{message}</AlertMessage>
        <AlertButton onClick={onClose}>ตกลง</AlertButton>
      </AlertBox>
    </Overlay>
  );
};

export default CustomAlert;
